export const Colors = {
  DARK_BLUE: "#143660",
  LIGHT_BLUE: "#7396bf",
  LIGHTER_BLUE: "#c5d2de",
  GREEN: "#8dc63f",
  TEAL: "#13a89e",
  LIGHT_GRAY: "#f1f1f1",
};
